import { FeaturesEnum } from '~/features/types';
import { PermissionEnum } from '~/roles/types';

export default [
  {
    path: '/documents',
    meta: {
      auth: true,
      permissions: [PermissionEnum.DOCUMENTS],
      feature: FeaturesEnum.DOCUMENTS,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'documents',
        component: () => import('~/documents/pages/Documents.vue'),
      },
    ],
  },
];
